module.exports = __webpack_public_path__ + "static/Yelp-a45a875e612ae439aebc2087bdd04af2.svg";